module.exports = __webpack_public_path__ + "jira-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/jira-logo.png
// module id = 1259
// module chunks = 74